var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlancMenuiserie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 525.89 279.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #201d19;\n      }\n\n      .cls-2 {\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-4, .cls-6 {\n        fill: none;\n      }\n\n      .cls-3, .cls-6 {\n        stroke-width: .75px;\n      }\n\n      .cls-3, .cls-7 {\n        stroke: #e63d11;\n      }\n\n      .cls-8, .cls-7 {\n        fill: #e63d11;\n      }\n\n      .cls-4 {\n        stroke-width: 7px;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        stroke: #fff;\n      }\n\n      .cls-5, .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-5, .cls-7 {\n        stroke-width: .5px;\n      }\n\n      .cls-10 {\n        fill: #7f8080;\n      }\n\n      .cls-11 {\n        fill: #088437;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    x: 382.25,
    y: 156,
    width: 152.64,
    height: 136.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.67,
    dy: 5.67
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "384.03 158.06 384.03 170.41 384.43 170.41 403.78 170.41 403.8 152.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61,35.18c1.54-1.87,3.56-4.02,6.16-6.16,2.32-1.91,4.56-3.36,6.51-4.45h23.71c.9.59,2.21,1.5,3.68,2.74,6.19,5.22,9.14,11.13,11.13,15.24,5.63,11.6,8.44,17.4,10.62,22.26,2.28,5.11,5.67,12.48,10.1,21.38l21.4-52.89c.41-1.19,1.63-4.24,4.79-6.51,2.06-1.47,4.09-2.01,5.29-2.23h23.54c1.89.41,5.74,1.55,8.49,4.97,3.42,4.25,3.06,9.47,2.74,14.04-.19,2.69-.82,6.93-3.07,11.8l-41.1,72.78v53.76h-35.91c-.79-.27-1.96-.76-3.13-1.71-2.96-2.4-3.69-5.89-4.11-7.88-.25-1.18-.5-2.95-.34-5.14v-38.69L61,35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.98,73.93c6.33,0,11.47,5.14,11.47,11.47s-5.14,11.47-11.47,11.47-11.47-5.14-11.47-11.47,5.14-11.47,11.47-11.47ZM220.09,105.56h19.77v64.06h-19.77v-64.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M316.61,160.65c-.23-.43-.44-.87-.63-1.32M317.34,161.89c-.26-.4-.5-.82-.73-1.24M357.81,163.09v-1.4h-.26c-.2.32-.41.63-.63.92M315.97,159.33c-.99-2.28-1.53-4.88-1.53-7.79,0-22.14,26.89-22.54,43.36-22.54,0-6.99-5.8-11.47-12.65-11.47-6.46,0-11.86,2.9-16.08,7.64l-10.54-10.81c7.25-6.85,17.79-10.28,28.21-10.28,23.07,0,29.26,11.73,29.26,33.08v21.79M352.93,141.65c-6.06,0-19.51.53-19.51,9.23,0,4.75,5.01,6.99,9.36,6.99,7.78,0,15.03-4.09,15.03-12v-4.22h-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M190.63,70.51h19.77v99.65h-19.77v-99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M384.03,157.02v-50.87h19.77v10.28h.26c4.22-7.78,9.75-11.86,18.45-11.86,2.24,0,4.75.13,6.59.66v18.06c-2.77-.79-5.54-1.32-8.44-1.32-15.03,0-16.87,8.7-16.87,21.49v9.09"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 444.73,
    cy: 116.67,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.79,159.68v-20.67c0-7.38-.13-16.87-10.28-16.87s-11.86,8.04-11.86,16.34v31.9h-19.77v-64.06h18.98v8.7h.26c2.64-5.01,9.1-10.28,18.72-10.28,20.03,0,23.72,13.18,23.72,30.32v24.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "289.77 159.99 289.77 170.38 309.56 170.38 309.56 159.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "356.92 164.14 356.92 170.41 375.99 170.41 375.99 160.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "189.77 182.41 243.2 182.41 290.22 162.66 351.72 162.66 407.27 148.69 438.05 123.82"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M411.58,190.78c-8.03-1.88-15.81-7.1-19.97-14.23-.15,7.47,1.27,15.87,4.7,22.51,1.74,3.37,3.48,7.57,7.13,10.1-1.03,5.5-2.08,15.44,1.69,26.5,6.59,19.35,24.82,32.99,44.57,36,1.72.26,31.91,4.33,51.43-18.86,2.26-2.68,16.72-20.46,12-44.57-5.21-26.62-29.2-37.49-31.71-38.57-23.63-10.21-48.48-.28-61.85,11.94-3.65,3.34-6.24,6.65-7.98,9.19Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "425.25 195.19 450.39 195.19 425.25 219.86 425.25 195.19"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M482.62,221.19l-.26-1.43h-.1c-.94,1.15-2.41,1.75-4.11,1.75-2.93,0-4.65-2.1-4.65-4.4,0-3.75,3.35-5.53,8.45-5.52v-.18c0-.76-.41-1.86-2.64-1.85-1.47,0-3.01.5-3.97,1.07l-.82-2.86c1-.57,2.96-1.29,5.59-1.29,4.79,0,6.31,2.83,6.31,6.21v5.02c0,1.37.07,2.68.23,3.49h-4.03ZM482.08,214.39c-2.35-.01-4.17.55-4.17,2.27,0,1.16.76,1.72,1.78,1.72,1.09,0,2.02-.73,2.31-1.65.07-.23.08-.51.08-.76v-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M492.95,206.8l2.15,7.07c.24.84.52,1.92.72,2.67h.09c.2-.78.43-1.84.64-2.68l1.77-7.07h4.77l-3.34,9.47c-2.06,5.71-3.44,8-5.07,9.44-1.54,1.35-3.19,1.85-4.31,1.97l-.96-3.77c.57-.11,1.26-.37,1.95-.76.68-.36,1.43-1.08,1.84-1.79.15-.23.25-.45.25-.64,0-.17-.04-.38-.2-.74l-5.27-13.17h4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M466.54,201.01h4.48v12.53c0,5.63-2.7,7.61-7.05,7.61-1.04,0-2.4-.16-3.28-.47l.5-3.61c.61.19,1.42.34,2.29.34,1.88,0,3.06-.84,3.06-3.93v-12.48Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "444.83 233.64 442.82 208.58 469.41 231.67 444.83 233.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "443.44 242.08 425.42 246.57 439.04 224.39 443.44 242.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "413.33 233.52 431.29 230.47 410.33 215.9 413.33 233.52"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.32,202.58c-.01-.3-.02-.66-.02-1.02h-.01c-.08.32-.18.67-.28.96l-.3.97h-.44l-.27-.96c-.08-.29-.16-.64-.22-.97h0c-.01.34-.03.72-.04,1.03l-.05.94h-.52l.16-2.48h.75l.24.83c.08.28.15.6.21.89h.01c.07-.29.15-.61.24-.89l.26-.82h.73l.13,2.48h-.54l-.04-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.81,202.48h-.91v.59h1.02v.46h-1.58v-2.48h1.53v.46h-.97v.52h.91v.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.3,203.52v-2.48h.65l.51.91c.15.26.29.57.41.85h0c-.03-.33-.05-.66-.05-1.04v-.72h.51v2.48h-.59l-.53-.95c-.15-.27-.31-.58-.43-.88h-.01c.02.33.02.68.02,1.08v.75h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M481.4,201.05v1.43c0,.43.16.65.45.65s.46-.21.46-.65v-1.43h.56v1.39c0,.76-.39,1.13-1.04,1.13s-.99-.35-.99-1.13v-1.38h.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483.91,201.05v2.48h-.56v-2.48h.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.41,202.95c.15.08.38.16.62.16.26,0,.39-.11.39-.27,0-.15-.12-.24-.41-.35-.41-.15-.68-.37-.68-.73,0-.42.35-.74.94-.74.28,0,.49.06.63.13l-.12.45c-.1-.05-.28-.12-.52-.12s-.36.11-.36.24c0,.16.14.23.46.35.44.16.64.39.64.74,0,.41-.32.77-1,.77-.28,0-.56-.08-.7-.15l.11-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.85,202.48h-.91v.59h1.02v.46h-1.58v-2.48h1.53v.46h-.97v.52h.91v.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M488.34,201.08c.18-.03.45-.05.74-.05.37,0,.63.06.8.2.15.12.23.29.23.52,0,.31-.22.53-.44.61h0c.17.08.27.25.33.47.08.28.15.6.2.7h-.57c-.04-.07-.1-.27-.17-.58-.07-.31-.17-.39-.4-.4h-.17v.97h-.56v-2.44ZM488.9,202.15h.22c.28,0,.44-.14.44-.36,0-.23-.16-.34-.41-.34-.13,0-.21,0-.25.02v.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.09,201.05v2.48h-.56v-2.48h.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.05,202.48h-.91v.59h1.02v.46h-1.58v-2.48h1.53v.46h-.97v.52h.91v.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M496.1,203.46c-.1.05-.33.11-.63.11-.86,0-1.3-.54-1.3-1.24,0-.84.61-1.31,1.35-1.31.29,0,.51.06.61.11l-.11.44c-.11-.05-.27-.09-.47-.09-.44,0-.79.27-.79.82,0,.5.29.81.79.81.17,0,.36-.03.47-.08l.08.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.08,203.52l-.79-2.48h.61l.3,1.05c.09.29.16.58.22.88h0c.06-.3.14-.59.23-.88l.31-1.06h.6l-.83,2.48h-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.84,203.52v-2.48h.65l.51.91c.15.26.29.57.41.85h0c-.03-.33-.05-.66-.05-1.04v-.72h.51v2.48h-.59l-.53-.95c-.15-.27-.31-.58-.43-.88h-.01c.02.33.02.68.02,1.08v.75h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503.64,202.26c0,.81-.49,1.3-1.22,1.3s-1.17-.56-1.17-1.26.48-1.3,1.21-1.3,1.18.57,1.18,1.25ZM501.85,202.29c0,.49.23.83.6.83s.6-.36.6-.84c0-.45-.21-.83-.6-.83s-.6.36-.6.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlancMenuiserie);
export default __webpack_public_path__ + "static/media/Blanc-Menuiserie.33a12343961bc8053bac81a4167fbb17.svg";
export { ForwardRef as ReactComponent };